import React, { useState, useContext, useEffect, useRef } from "react";
import {
    Navbar,
    NavbarBrand,
    NavItem,
    NavLink,
    NavbarText,
    Container,
    Card,
    CardBody,
    CardText
} from "reactstrap";
import { ShoppingCartOutlined, DownOutlined, MinusOutlined, PlusOutlined, CloseOutlined, DeleteOutlined } from "@ant-design/icons";
import { Badge, Button, Col, Row, Typography, Space, Modal, Radio, Popover, Avatar, Flex, Segmented } from "antd";
import { EnvironmentFilled, ClockCircleFilled } from "@ant-design/icons";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "../styles/NavMenu.css";
import CartDrawer from "./cart/CartDrawer";
import { PublicContext } from "./PublicContext";
import UpsellUtensilModal from "./menu/UpsellUtensilModal";
import LocationOrderType from "./LocationOrderType";
import dayjs from 'dayjs';

export default function NavMenu(props) {
    const navigate = useNavigate();
    //const [messageApi, contextHolder] = message.useMessage();
    const [collapsed, setCollapsed] = useState(true);
    const {
        stores,
        cartNum,
        cartPrice,
        sideCartVisible,
        setSideCartVisible,
        cart,
        products,
        isAbove991px,
        setCart,
        setCartNum,
        setCartPrice,
        setSpinning,
        openNotification,
        deliveryOrPickUp,
        setDeliveryOrPickUp,
        menuUrl,
        selectedStore
    } = useContext(PublicContext);
    const [openDrawer, setOpenDrawer] = useState(false);

    const location = useLocation();
    //console.log(location);

    const pagesToShowElement = ["/menu", "/cart", "/checkout"];
    //const [shouldShowElement, setShouldShowElement] = useState(false);
    const [shouldShowElement, setShouldShowElement] = useState(
        pagesToShowElement.includes(location.pathname) &&
        sessionStorage.getItem("selectedStore") &&
        sessionStorage.getItem("deliveryOrPickUp"));
    const sideCartRef = useRef(null);
    // Parse the query parameters from the location search string
    const queryParams = new URLSearchParams(location.search);
    // Get the values of storeCode and storeId from the query parameters
    const storeCode = queryParams.get("storeCode") ?? null;
    const storeId = queryParams.get("storeId") ?? null;
    const [loading, setLoading] = useState(true);
    //const [storeName, setStoreName] = useState(stores.find(store => store.storeCode === JSON.parse(sessionStorage.getItem("selectedStore"))
    //    .storeCode).storeName);

    const [storeName, setStoreName] = useState(() => {
        const selectedStore = sessionStorage.getItem("selectedStore");
        if (selectedStore) {
            const store = stores.find(store => store.storeCode === JSON.parse(selectedStore).storeCode);
            return store ? store.storeName : '';
        }
        return '';
    });

    const [modalVisible, setModalVisible] = useState(false);

    const [upsellModalVisible, setUpsellModalVisible] = useState(false);

    const [checked, setChecked] = useState(deliveryOrPickUp === "pickup");
    const [isFixed, setIsFixed] = useState(false);

    const handleModalClose = () => {
        setModalVisible(false);
    };

    const handleUpsellUtensilModalClose = () => {
        setUpsellModalVisible(false);
    };

    //useEffect(() => {
    //    window.addEventListener('scroll', handleScroll);
    //    return () => {
    //        window.removeEventListener('scroll', handleScroll);
    //    };
    //}, []);

    const handleChange = () => {
        //console.log(checked + " " + selectedStore.current.storeCode);
        //if (checked && selectedStore.current.storeCode === "GU") {
        //    openNotification("error", "Sorry, this location currently does not have delivery service.");
        //}
        //else {
        setChecked(!checked);
        if (checked) {
            //console.log("delivery");
            sessionStorage.setItem("deliveryOrPickUp", "delivery");
            setDeliveryOrPickUp("delivery");
        }
        else {
            //console.log("pickup");
            sessionStorage.setItem("deliveryOrPickUp", "pickup");
            setDeliveryOrPickUp("pickup");
        }
        //}
    };

    useEffect(() => {
        // Only run this effect if the current path is "/menu"
        if (location.pathname === '/menu') {
            // Get the stored menu URL from sessionStorage
            const storedMenuUrl = sessionStorage.getItem("menuUrl");

            // Check if storedMenuUrl exists and the current URL has no query parameters
            if (storedMenuUrl && !location.search) {
                // Parse the storedMenuUrl to get the query parameters
                const queryParams = new URLSearchParams(storedMenuUrl);
                const newUrl = `${location.pathname}?${queryParams.toString()}`;

                // Replace the current URL with the new URL with query parameters
                navigate(newUrl, { replace: true });
            }
        }
    }, [navigate, location]);

    useEffect(() => {
        if (!sessionStorage.getItem("deliveryOrPickUp")) {
            setModalVisible(true);
        }

        if (location.pathname === '/menu' && storeId && storeCode) {
            sessionStorage.setItem(
                "selectedStore",
                JSON.stringify({ storeId: storeId, storeCode: storeCode })
            );
        }
        //else if (location.pathname === '/menu' && !(storeId && storeCode) && !sessionStorage.getItem("selectedStore")) {
        else if (location.pathname === '/menu' && !(storeId && storeCode)) {
            //navigate('/');
            window.location.href = 'https://www.mandarinrestaurant.com/order-online/';
        }

    }, []);

    useEffect(() => {
        if (sessionStorage.getItem("deliveryOrPickUp") === "pickup") {
            //console.log("Pickup");
            setDeliveryOrPickUp("pickup");
            setChecked(true);
        }
        else {
            //console.log("delivery");
            setDeliveryOrPickUp("delivery");
            setChecked(false);
        }
    }, [sessionStorage.getItem("deliveryOrPickUp")]);

    useEffect(() => {
        //console.log("Change Location useEffect");
        if (sessionStorage.getItem("selectedStore")) {
            setStoreName(stores.find(store => store.storeCode === JSON.parse(sessionStorage.getItem("selectedStore"))
                .storeCode).storeName);
        }
    }, [sessionStorage.getItem("selectedStore")]);

    useEffect(() => {
        setShouldShowElement(
            pagesToShowElement.includes(location.pathname) &&
            sessionStorage.getItem("selectedStore") !== null &&
            sessionStorage.getItem("deliveryOrPickUp") !== null);
    }, [location]);

    //useEffect(() => {
    //    console.log("shouldShowElement is " + shouldShowElement);
    //    if (shouldShowElement) {
    //        console.log("in shouldShowElement if");
    //        console.log(modalVisible);
    //        setModalVisible(true);
    //    }
    //    else {
    //        setModalVisible(false);
    //    }
    //}, [shouldShowElement]);

    useEffect(() => {
        setShouldShowElement(
            pagesToShowElement.includes(location.pathname) &&
            sessionStorage.getItem("selectedStore") !== null &&
            sessionStorage.getItem("deliveryOrPickUp") !== null);
    }, [sessionStorage.getItem("deliveryOrPickUp")]);

    const handleSideCartClickAway = (event) => {
        // Check if the clicked element is outside the fixed div
        if (!event.target.closest('.viewCartBtn') &&
            !event.target.closest('.floatingCartBtn') &&
            !event.target.closest('.menu-cart-nav') &&
            !event.target.closest('#sideCart')
        ) {
            setSideCartVisible(false);
        }
    };

    const toggleVisibility = () => {
        setSideCartVisible(!sideCartVisible);
    };
    function selectMenuItem(item) {
        setOpenDrawer(true);
    }
    function toggleNavbar() {
        setCollapsed((prev) => !prev);
    }
    function changeQuantity(
        originalQuantity,
        newQuantity,
        product,
        originalProduct
    ) {
        //console.log("change quantity: " + originalQuantity + " " + newQuantity);
        if (originalQuantity > newQuantity) {
            if (newQuantity < 0) {
                removeQuantity(originalQuantity, product, originalProduct);
            } else {
                removeQuantity(
                    originalQuantity - newQuantity,
                    product,
                    originalProduct
                );
            }
        } else if (originalQuantity < newQuantity) {
            addQuantity(newQuantity - originalQuantity, product, originalProduct);
        }
    }
    async function addQuantity(addQuantity, product, originalProduct) {
        // console.log(product);
        setSpinning(true);
        //console.log("Add Quantity");
        if (window.gtag) {
            window.gtag('event', 'NavMenuAddQuantity', {
                event_category: 'Button',
                event_label: 'NavMenuAddQuantity',
            });
        }
        let postData = [];
        if (product.itemPromoType === "BuyX") {
            postData.push({
                ProductCode: product.productCode,
                ProductName: product.productName,
                Quantity: addQuantity,
                SingleProductPrice: product.price,
                ItemPromoType: "BuyX",
                LinkedPromoProductCode: product.linkedPromoProductCode,
            });
            let freeItem = products.find(
                (p) => p.productCode === product.linkedPromoProductCode
            );
            postData.push({
                ProductCode: freeItem.productCode,
                ProductName: freeItem.productName,
                Quantity: addQuantity,
                SingleProductPrice: 0,
                ItemPromoType: "GetY",
                LinkedPromoProductCode: product.productCode,
            });
        } else {
            postData = [
                {
                    ProductCode: originalProduct.productCode,
                    ProductName: originalProduct.productName,
                    Quantity: addQuantity,
                    SingleProductPrice: originalProduct.price,
                    // ItemPromoType: "BuyX/GetY"
                },
            ];
        }
        //console.log(JSON.stringify(postData));
        await fetch("api/Carts/add-to-cart", {
            // await fetch("api/<OrderController>", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-type": "application/json",
            },
            body: JSON.stringify({
                Cart: postData,
                OrderType: sessionStorage.getItem("deliveryOrPickUp"),
                StoreCode: JSON.parse(sessionStorage.getItem("selectedStore")).storeCode
            }),
        })
            .then(async (response) => {
                setSpinning(false);
                //console.log(response);
                const responseData = await response.json();
                //console.log(responseData);
                const totalQuantity = responseData.reduce(
                    (acc, obj) => acc + obj.quantity,
                    0
                );

                const numberAdded = totalQuantity - cartNum;

                setCartNum(totalQuantity);
                setCartPrice(responseData[0].orderSubtotal);

                if (numberAdded > addQuantity) {
                    if (addQuantity > 1) {
                        openNotification("success", addQuantity + " items and promotion are added!");
                        //messageApi.info(numberAdded + " items removed!");
                    } else {
                        openNotification("success", addQuantity + " item and promotion are added!");
                        //messageApi.info(numberAdded + " item removed!");
                    }
                }
                else {
                    if (addQuantity > 1) {
                        openNotification("success", addQuantity + " items are added!");
                        //messageApi.info(numberAdded + " items removed!");
                    } else {
                        openNotification("success", addQuantity + " item is added!");
                        //messageApi.info(numberAdded + " item removed!");
                    }
                }

                setCart(responseData);
                localStorage.setItem("cart", JSON.stringify(responseData));
            })
            .catch((error) => {
                setSpinning(false);
                openNotification("error", "Something went wrong. Please try again.");
                //console.error(error);
                // setSubmitDistabled(false);
            });
    }
    async function removeQuantity(removeQuantity, product, originalProduct) {
        //console.log("removeQuantity");
        setSpinning(true);
        if (window.gtag) {
            window.gtag('event', 'NavMenuRemoveQuantity', {
                event_category: 'Button',
                event_label: 'NavMenuRemoveQuantity',
            });
        }
        let postData;
        if (product.itemPromoType === "BuyX" || product.itemPromoType === "Buy1") {
            postData = {
                ProductCode: product.productCode,
                ProductName: product.productName,
                CartId: product.cartId,
                Quantity: removeQuantity,
                SingleProductPrice: product.price,
                ItemPromoType: product.itemPromoType,
                LinkedPromoProductCode: product.linkedPromoProductCode,
            };
        } else {
            postData = {
                ProductCode: originalProduct.productCode,
                ProductName: originalProduct.productName,
                CartId: product.cartId,
                Quantity: removeQuantity,
                SingleProductPrice: originalProduct.price,
                // ItemPromoType:
            };
        }

        console.log(selectedStore.current);
        //console.log(JSON.stringify(postData));
        await fetch("api/Carts/remove-from-cart", {
            // await fetch("api/<OrderController>", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-type": "application/json",
            },
            body: JSON.stringify({
                Cart: postData,
                OrderType: sessionStorage.getItem("deliveryOrPickUp"),
                StoreCode: JSON.parse(sessionStorage.getItem("selectedStore")).storeCode
            }),
        })
            .then(async (response) => {
                setSpinning(false);
                //console.log(response);
                const responseData = await response.json();
                //console.log(responseData);
                const totalQuantity = responseData.reduce(
                    (acc, obj) => acc + obj.quantity,
                    0
                );

                const numberRemoved = cartNum - totalQuantity;

                setCartNum(totalQuantity);
                if (responseData.length > 0) {
                    setCartPrice(responseData[0].orderSubtotal);
                }
                else {
                    setCartPrice(0);
                }

                //console.log("number Removed " + numberRemoved + " : " + removeQuantity);

                if (numberRemoved > removeQuantity) {
                    if (removeQuantity > 1) {
                        openNotification("success", removeQuantity + " items and promotion are removed!");
                    } else {
                        openNotification("success", removeQuantity + " item and promotion are removed!");
                    }
                }
                else {
                    if (removeQuantity > 1) {
                        openNotification("success", removeQuantity + " items are removed!");
                    } else {
                        openNotification("success", removeQuantity + " item is removed!");
                    }
                }

                setCart(responseData);
                localStorage.setItem("cart", JSON.stringify(responseData));
            })
            .catch((error) => {
                setSpinning(false);
                openNotification("error", "Something went wrong. Please try again.");
                //console.error(error);
                // setSubmitDistabled(false);
            });
    }
    function renderDrawer() {
        return <CartDrawer setOpenDrawer={setOpenDrawer} />;
    }
    function renderSideCart() {
        //console.log("render Cart List");
        //console.log(cart)
        return (
            <>
                <div className={`overlay ${sideCartVisible ? 'visible' : ''}`} onClick={() => setSideCartVisible(false)}></div>

                <div id="sideCart"
                    className={sideCartVisible ? 'sideCartVisible' : 'sideCartInvisible'}
                >
                    <div>
                        <Button
                            className={"closeSideCartBtn"}
                            shape="circle"
                            icon={<CloseOutlined />}
                            onClick={() => setSideCartVisible(false)}
                        />
                        <div style={{ textAlign: "center" }}>
                            <Typography.Title level={5}>Subtotal</Typography.Title>
                            <Typography.Title level={5}>${cart[0].orderSubtotal}</Typography.Title>
                            <Button
                                className="btn-primary goCheckOutBtn"
                                shape="round"
                                onClick={() => { setSideCartVisible(false); setUpsellModalVisible(true) }}
                            >
                                Go To Checkout
                            </Button>
                            <hr></hr>
                        </div>
                    </div>
                    <div id="sideCartList">
                        {cart.map((cartItem, index) => {
                            const product = products.find(
                                (p) => p.productCode === cartItem.productCode
                            );
                            // console.log(cartItem.productCode);
                            console.log(product);
                            return (
                                <div
                                    key={(cartItem.itemPromoType || "null") + cartItem.productCode}
                                >
                                    <Row className="d-flex justify-content-between align-items-center">
                                        {isAbove991px && cart.length <= 3 ?
                                            <Col span={24} className="w-100 cart-item-col">
                                                <img
                                                    width="100%"
                                                    alt={cartItem.productName}
                                                    src={`https://takeoutpictures.blob.core.windows.net/weborderpictures/medium/${encodeURIComponent(product.pictureURL)}`}
                                                    // fluid
                                                    className="rounded-3 sideCartImg"
                                                    onError={({ currentTarget }) => {
                                                        currentTarget.style.display = 'none';
                                                    }}
                                                    //onError={(e) => {
                                                    //    e.target.src = "https://takeoutpictures.blob.core.windows.net/weborderpictures/medium/img-placeholder.png";
                                                    //    e.target.onerror = null;
                                                    //}}
                                                />
                                            </Col>
                                            :
                                            <></>}

                                        <Col span={24} className="w-100 cart-item-col">
                                            <Typography.Title level={5} className="text-black flex-wrap">
                                                {product.productName} {cartItem.singleProductPrice === 0 && <> (Promotional Item)</>}
                                            </Typography.Title>
                                        </Col>
                                        <Col span={9} className="w-100 cart-item-col">
                                            {cartItem.singleProductPrice * cartItem.quantity <
                                                product.price * cartItem.quantity ? (
                                                <>
                                                    <strike>
                                                        <Typography.Title level={5} className="mb-0">
                                                            ${(product.price * cartItem.quantity).toFixed(2)}
                                                        </Typography.Title>
                                                    </strike>

                                                    <Typography.Title level={5} className="mb-0">
                                                        $
                                                        {(
                                                            cartItem.singleProductPrice * cartItem.quantity
                                                        ).toFixed(2)}
                                                    </Typography.Title>
                                                </>
                                            ) : (
                                                <Typography.Title level={5} className="mb-0">
                                                    $
                                                    {(
                                                        cartItem.singleProductPrice * cartItem.quantity
                                                    ).toFixed(2)}
                                                </Typography.Title>
                                            )}
                                        </Col>
                                        <Col span={15} className="w-100 d-flex align-items-center justify-content-end cart-item-col">
                                            <div className="cartQuantityControl">
                                                <Button
                                                    color="link"
                                                    className="qty-btn"
                                                    shape="circle"
                                                    style={{ fontSize: '16px', background: "transparent", boxShadow: "none" }}
                                                    onClick={() => {
                                                        changeQuantity(
                                                            cartItem.quantity,
                                                            cartItem.quantity - 1,
                                                            cartItem,
                                                            product
                                                        );
                                                    }}
                                                    icon={
                                                        cartItem.quantity > 1 ?
                                                            <MinusOutlined style={{ fontSize: '18px' }} />
                                                            :
                                                            <DeleteOutlined style={{ fontSize: '18px' }} />
                                                    }
                                                />
                                                <Typography.Title
                                                    level={4}
                                                    className="align-items-center"
                                                    style={{ paddingLeft: "10px", paddingRight: "5px", margin: "0", minWidth: "26px" }}
                                                >
                                                    {cartItem.quantity}
                                                </Typography.Title>
                                                <Button
                                                    color="link"
                                                    className="qty-btn"
                                                    shape="circle"
                                                    style={{ fontSize: '16px', background: "transparent", boxShadow: "none" }}
                                                    onClick={() => {
                                                        changeQuantity(
                                                            cartItem.quantity,
                                                            cartItem.quantity + 1,
                                                            cartItem,
                                                            product
                                                        );
                                                    }}
                                                    icon={<PlusOutlined style={{ fontSize: '18px' }} />}
                                                />
                                            </div>
                                        </Col>
                                    </Row>

                                    <hr className="my-4" />
                                </div>
                            );
                        })}
                    </div>
                </div>
            </>
        );
    }

    const locationContent = (
        <div>
            {/*<Button onClick={() => window.location.href = 'https://www.mandarinrestaurant.com/order-online/'}>Change Location</Button>*/}
            <Button onClick={() => navigate(`/`)}>Change Location</Button>
        </div>
    );

    return (
        <>
            <header>
                <Navbar className="top-navbar top-navbar-thin justify-content-center navbar-toggleable-sm ng-white">
                    <div className="container" style={{ display: "flex", position: "relative" }}>
                        {/*<Container className="navbar-container">*/}
                        <Row style={{ width: "100%" }}>

                            <Col className="navbar-logo" xs={24} sm={24} md={18} lg={20} style={{ zIndex: "100", display: "flex", alignItems: "center", justifyContent: "left" }}>
                                <NavbarBrand className="navbar-logo-icon" tag={Link} to="https://www.mandarinrestaurant.com/">
                                    {/*<NavbarBrand tag={Link} >*/}
                                    {/*<img*/}
                                    {/*    id="mandarin-full-logo"*/}
                                    {/*    alt={"Mandarin Restaurant"}*/}
                                    {/*    src="/pictures/mandarin_logo.png"*/}
                                    {/*/>*/}
                                    <img
                                        id="mandarin-full-logo-M"
                                        alt={"Mandarin Restaurant"}
                                        src="/pictures/Mandarin Logo - M Only No Circle.png"
                                    />
                                </NavbarBrand>

                                {shouldShowElement &&
                                    <Space>
                                        <div className="nav-order-loctime">
                                            <Popover trigger="click" content={locationContent} className="nav-order-location" style={{ height: "auto" }}>
                                                <Button className="nav-order-location btn-outline" style={{ height: "auto" }}>
                                                    <EnvironmentFilled className="nav-order-location-logo" style={{ margin: "auto", verticalAlign: "middle" }} />
                                                    {storeName} <span className="nav-order-location-location">&nbsp;Location</span>
                                                </Button>
                                            </Popover>
                                            {/*<div className="nav-order-dash">-</div>*/}
                                        </div>

                                        {/*<div className="nav-order-time">*/}
                                        {/*    <ClockCircleFilled className="nav-order-location-logo" />*/}
                                        {/*    {deliveryOrPickUp === 'delivery' ? <>Delivery </> : <>Pickup </>}*/}
                                        {/*    {sessionStorage.getItem("scheduleTime") === "now" || sessionStorage.getItem("scheduleTime") == null ?*/}
                                        {/*        <>*/}
                                        {/*            Now*/}
                                        {/*        </>*/}
                                        {/*        :*/}
                                        {/*        <Space size="small">*/}
                                        {/*            {dayjs(sessionStorage.getItem("scheduleDate")).format('ddd')}*/}
                                        {/*            {sessionStorage.getItem("scheduleDate")}*/}
                                        {/*            {sessionStorage.getItem("scheduleTime")}*/}
                                        {/*        </Space>*/}
                                        {/*    }*/}
                                        {/*</div>*/}

                                        {shouldShowElement &&
                                            <Col className="navbar-switch" xs={24} sm={24} md={6} lg={6} style={{ display: "flex", alignItems: "center", justifyContent: "left" }}>
                                                <div className="custom-switch" onClick={handleChange}>
                                                    <div className="switch-container">
                                                        <span className={`switch-label ${!checked ? 'active' : ''}`}>Delivery</span>
                                                        <span className={`switch-label ${checked ? 'active' : ''}`}>Pickup</span>
                                                        <div className="switch-button-container">
                                                            <div className={`switch-button ${checked ? 'checked' : ''}`}>
                                                                {checked ? 'Pickup' : 'Delivery'}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        }
                                    </Space>
                                }
                            </Col>

                            {shouldShowElement &&
                                <>
                                    {cartNum > 0 &&
                                        <Col xs={24} sm={24} md={24} lg={4} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                            <ul className="navbar-nav">
                                                <NavItem className="menu-cart-nav">
                                                    <NavLink tag={Link} to="#">
                                                        <Button
                                                            className="menu-cart-btn"
                                                            ref={sideCartRef}
                                                            onClick={() => {
                                                                if (location.pathname === "/" || location.pathname === "/menu" || location.pathname === "/locationsmap") {
                                                                    setSideCartVisible(true);
                                                                }
                                                            }
                                                            }
                                                            style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                                                            shape="round"
                                                            icon={
                                                                <Badge count={cartNum} className="menu-cart-icon-badge cartNumBadge">
                                                                    <ShoppingCartOutlined className="menu-cart-icon" />
                                                                </Badge>}
                                                        >

                                                            {cartNum > 0 ?
                                                                <div style={{ marginLeft: "10px" }}>
                                                                    • ${cartPrice}
                                                                </div>
                                                                :
                                                                <></>
                                                            }

                                                        </Button>
                                                    </NavLink>
                                                </NavItem>
                                            </ul>
                                        </Col>
                                    }
                                </>
                            }
                        </Row>

                        {/*{(!loading && shouldShowElement) && (*/}
                        {/*    <Navbar*/}
                        {/*        className="navbar-expand-sm lower-navbar justify-content-center navbar-toggleable-sm ng-white box-shadow"*/}
                        {/*    >*/}
                        {/*        <NavbarText className="navbar-store">*/}
                        {/*            <Container>*/}
                        {/*                <Card*/}
                        {/*                    className="navbar-store-card"*/}
                        {/*                    onClick={() => handleNavbarStoreCardClick()}*/}
                        {/*                >*/}
                        {/*                    <CardBody className="navbar-store-card-body" style={{ textTransform: 'capitalize', padding: "0" }}>*/}
                        {/*                        <div className="navbar-store-card-body-text-top" >*/}
                        {/*                            <Space>*/}
                        {/*                                <EnvironmentFilled style={{ fontSize: 20 }} />*/}
                        {/*                                <>*/}
                        {/*                                    {*/}
                        {/*                                        stores.find(store => store.storeCode === JSON.parse(sessionStorage.getItem("selectedStore"))*/}
                        {/*                                            .storeCode).storeName + " Location"*/}
                        {/*                                    }*/}
                        {/*                                </>*/}
                        {/*                            </Space>*/}
                        {/*                        </div>*/}
                        {/*                        <div className="navbar-store-card-body-text-bottom" >*/}
                        {/*                            <Space>*/}
                        {/*                                <ClockCircleFilled style={{ fontSize: 20 }} />*/}
                        {/*                                {*/}
                        {/*                                    sessionStorage.getItem("deliveryOrPickUp") === "delivery" ?*/}
                        {/*                                        (<>Delivery - </>) : (<>Pickup - </>)*/}
                        {/*                                }*/}
                        {/*                                {sessionStorage.getItem("scheduleTime") === "now" || sessionStorage.getItem("scheduleTime") == null ?*/}
                        {/*                                    <>*/}
                        {/*                                        Now*/}
                        {/*                                    </>*/}
                        {/*                                    :*/}
                        {/*                                    <>*/}
                        {/*                                        {dayjs(sessionStorage.getItem("scheduleDate")).format('ddd')}*/}
                        {/*                                        {sessionStorage.getItem("scheduleDate")}*/}
                        {/*                                        {sessionStorage.getItem("scheduleTime")}*/}
                        {/*                                    </>*/}
                        {/*                                }*/}
                        {/*                            </Space>*/}
                        {/*                        </div>*/}
                        {/*                    </CardBody>*/}
                        {/*                    <DownOutlined className="down-arrow" />*/}
                        {/*                </Card>*/}
                        {/*            </Container>*/}
                        {/*        </NavbarText>*/}
                        {/*    </Navbar>*/}
                        {/*)}*/}
                        {/*</Container>*/}
                    </div>
                </Navbar>

                {/*<Navbar*/}
                {/*    className="navbar-expand-sm lower-navbar justify-content-center navbar-toggleable-sm ng-white box-shadow"*/}
                {/*    style={{ backgroundColor: "#DEE2BE" }}*/}
                {/*>*/}
                {/*    <ul className="navbar-nav flex-grow">*/}
                {/*        */}{/*<NavItem>*/}
                {/*        */}{/*    <NavLink tag={Link} to="/">*/}
                {/*        */}{/*        Home*/}
                {/*        */}{/*    </NavLink>*/}
                {/*        */}{/*</NavItem>*/}
                {/*        */}{/*<NavItem>*/}
                {/*        */}{/*    <NavLink tag={Link} to="/locationsmap">*/}
                {/*        */}{/*        Locations*/}
                {/*        */}{/*    </NavLink>*/}
                {/*        */}{/*</NavItem>*/}
                {/*        <NavItem>*/}
                {/*            */}{/*<NavLink tag={Link} to="/menu">*/}
                {/*            <NavLink tag={Link} to={'/menu?' + menuUrl}>*/}
                {/*                Menu*/}
                {/*            </NavLink>*/}
                {/*        </NavItem>*/}
                {/*        <NavItem className="menu-cart-nav">*/}
                {/*            <NavLink tag={Link} to="#">*/}
                {/*                <Button*/}
                {/*                    className="btn-primary menu-cart-btn"*/}
                {/*                    ref={sideCartRef}*/}
                {/*                    onMouseEnter={() => {*/}
                {/*                        if (location.pathname === "/" || location.pathname === "/menu" || location.pathname === "/locationsmap") {*/}
                {/*                            setSideCartVisible(true);*/}
                {/*                        }*/}
                {/*                    }*/}
                {/*                    }*/}
                {/*                    shape="round"*/}
                {/*                    icon={*/}
                {/*                        <Badge count={cartNum} className="menu-cart-icon">*/}
                {/*                            <ShoppingCartOutlined*/}
                {/*                                style={{ fontSize: "22px", color: "white" }}*/}
                {/*                            />*/}
                {/*                        </Badge>}*/}
                {/*                >*/}
                {/*                    {cartNum > 0 ? <> - ${cartPrice}</> : <></>}*/}
                {/*                </Button>*/}
                {/*            </NavLink>*/}
                {/*        </NavItem>*/}
                {/*        */}{/*<NavItem>*/}
                {/*        */}{/*  <NavLink tag={Link} to="/order">*/}
                {/*        */}{/*    Order*/}
                {/*        */}{/*  </NavLink>*/}
                {/*        */}{/*</NavItem>*/}
                {/*    </ul>*/}
                {/*</Navbar>*/}
            </header>
            {openDrawer && renderDrawer()}
            {cart?.length > 0 ? renderSideCart() : <></>}
            <UpsellUtensilModal visible={upsellModalVisible} onClose={handleUpsellUtensilModalClose} />
        </>
    );
}